import { createSlice } from '@reduxjs/toolkit';
import {
    getLatestNews,
    getNewsList,
    getNewsBySlug,
} from '../thunks/newsThunks';

const initialState = {
    latestNews: [],
    latestNewsLoading: false,
    latestNewsError: null,

    newsList: [],
    newsListLoading: false,
    newsListError: null,
    newsPagination: {
        total: 0,
        limit: 10,
        offset: 0,
        hasMore: false,
    },

    currentNews: null,
    currentNewsLoading: false,
    currentNewsError: null,
};

const newsSlice = createSlice({
    name: 'news',
    initialState,
    reducers: {
        clearCurrentNews: (state) => {
            state.currentNews = null;
            state.currentNewsError = null;
        },
        clearNewsList: (state) => {
            state.newsList = [];
            state.newsPagination = initialState.newsPagination;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLatestNews.pending, (state) => {
                state.latestNewsLoading = true;
                state.latestNewsError = null;
            })
            .addCase(getLatestNews.fulfilled, (state, action) => {
                state.latestNewsLoading = false;
                state.latestNews = action.payload || [];
            })
            .addCase(getLatestNews.rejected, (state, action) => {
                state.latestNewsLoading = false;
                state.latestNewsError = action.payload;
            });

        builder
            .addCase(getNewsList.pending, (state, action) => {
                state.newsListLoading = true;
                state.newsListError = null;
                if (
                    action.meta?.arg?.offset === 0 ||
                    !action.meta?.arg?.offset
                ) {
                    state.newsList = [];
                }
            })
            .addCase(getNewsList.fulfilled, (state, action) => {
                state.newsListLoading = false;
                const payload = action.payload;

                if (payload) {
                    const offset = action.meta?.arg?.offset || 0;
                    if (offset > 0) {
                        const existingIds = new Set(
                            state.newsList.map((n) => n.id),
                        );
                        const newItems = (payload.data || payload || []).filter(
                            (item) => !existingIds.has(item.id),
                        );
                        state.newsList = [...state.newsList, ...newItems];
                    } else {
                        state.newsList = payload.data || payload || [];
                    }

                    if (payload.pagination) {
                        state.newsPagination = payload.pagination;
                    }
                }
            })
            .addCase(getNewsList.rejected, (state, action) => {
                state.newsListLoading = false;
                state.newsListError = action.payload;
            });

        builder
            .addCase(getNewsBySlug.pending, (state) => {
                state.currentNewsLoading = true;
                state.currentNewsError = null;
            })
            .addCase(getNewsBySlug.fulfilled, (state, action) => {
                state.currentNewsLoading = false;
                state.currentNews = action.payload || null;
            })
            .addCase(getNewsBySlug.rejected, (state, action) => {
                state.currentNewsLoading = false;
                state.currentNewsError = action.payload;
            });
    },
});

export const { clearCurrentNews, clearNewsList } = newsSlice.actions;

export const selectLatestNews = (state) => state.commonData.news.latestNews;
export const selectLatestNewsLoading = (state) =>
    state.commonData.news.latestNewsLoading;

export const selectNewsList = (state) => state.commonData.news.newsList;
export const selectNewsListLoading = (state) =>
    state.commonData.news.newsListLoading;
export const selectNewsPagination = (state) =>
    state.commonData.news.newsPagination;

export const selectCurrentNews = (state) => state.commonData.news.currentNews;
export const selectCurrentNewsLoading = (state) =>
    state.commonData.news.currentNewsLoading;

export const news = newsSlice.reducer;

export default newsSlice.reducer;
